import { Element, Node } from 'slate';

export type TagBinding = {
  tagId: string;
  continuedAt?: string;
};

export const BLOCK_TAG_CARRIER_TYPES = ['reference-table', 'image', 'paragraph', 'custom-formatting', 'bulleted-list', 'numbered-list'] as const;
export type BlockTagCarrierType = (typeof BLOCK_TAG_CARRIER_TYPES)[number];

export const TEXT_BLOCK_TAG_CARRIER_TYPES: ReadonlySet<string> = new Set<BlockTagCarrierType>([
  'paragraph',
  'custom-formatting',
  'bulleted-list',
  'numbered-list',
]);

export function isBlockTagCarrierType(type: unknown): type is BlockTagCarrierType {
  return typeof type === 'string' && (BLOCK_TAG_CARRIER_TYPES as readonly string[]).includes(type);
}

export function hasBlockTags(node: Node): boolean {
  if (!Element.isElement(node)) return false;
  const tags = (node as { tags?: unknown }).tags;
  return Array.isArray(tags) && tags.length > 0;
}

export function getBlockTagBindings(node: Node): TagBinding[] {
  if (!Element.isElement(node)) return [];
  const tags = (node as { tags?: unknown }).tags;
  return Array.isArray(tags) ? (tags as TagBinding[]) : [];
}

export function getBlockTagIds(node: Node): string[] {
  return getBlockTagBindings(node).map((b) => b.tagId);
}
